<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="22" fill="green" viewBox="0 -960 960 960" width="22"><path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z"/></svg>
</template>